import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import SiteApi from '@/api/SiteApi'
import { ISite } from '@/api/SiteApi/types'
import RegisterOrder from '../RegisterOrder/RegisterOrder.vue'
import Select from '@/components/Select/Select.vue'
import { scopedTranslation } from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { sT } = scopedTranslation('newOrder')
const router = useRouter()
const loading = ref(true)
const currentCompanyUuid = router.currentRoute.value.query.companyUuid as string
const selectedSite = ref('')
const orderCreated = ref(false)
const sitesForCompany = ref<ISite[] | null>([])

const siteOptions = computed(() =>
  sitesForCompany.value?.map(site => ({
    label: `${site.name} (${site.company.name})`,
    value: site.uuid,
  })),
)

const handleSiteSelect = (value: string) => {
  selectedSite.value = value
}

const setOrderCreated = () => {
  orderCreated.value = true
}

const reset = () => {
  selectedSite.value = ''
  orderCreated.value = false
}

onMounted(async () => {
  sitesForCompany.value = await SiteApi.getAllForCompany(currentCompanyUuid)
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, _toDisplayString(_unref(sT)('selectSite')), 1),
    _createVNode(Select, {
      modelValue: selectedSite.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedSite).value = $event)),
        handleSiteSelect
      ],
      options: _unref(siteOptions)
    }, null, 8, ["modelValue", "options"]),
    _createVNode(RegisterOrder, {
      onCreatedOrder: setOrderCreated,
      onReset: reset,
      siteUuid: selectedSite.value
    }, null, 8, ["siteUuid"])
  ], 64))
}
}

})